<template>
	<section class="main-content benefits">
		<div class="row">
			<div class="columns column4">
				<h2 class="subtitle">{{ subtitle }}</h2>
				<h2>{{ title }}</h2>
				<ul>
					<li v-for="(benefit, key) in benefits" :key="key">
						<span>{{ benefit }}</span>
					</li>
				</ul>
				<book-button class="button button-cta reserve-now" aria-label="Reserve now">
					<span>{{ $t('bookNow') }}</span>
				</book-button>
			</div>
		</div>
		<picture>
			<source v-if="image.imageWebp" :srcset="image.imageWebp" type="image/webp" />
			<source :srcset="image" />
			<img class="fade-image" :src="image.image" :alt="image.imageAlt" loading="lazy" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	benefits: { type: Array, default: () => [] },
	image: {
		type: Object,
		default: () => ({
			image: '',
			imageAlt: '',
			imageWebp: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.benefits .fade-image {
	opacity: 1;
}

.benefits {
	position: relative;
	padding: 75px 0;
}

.benefits .row {
	z-index: 2;
	position: relative;
}

.benefits .column4 {
	background: #f6efd3;
	box-shadow: 0 18px 18px rgb(0 0 0 / 25%);
	backdrop-filter: blur(34px);
	padding: 60px;
}

.benefits ul {
	list-style: none;
	font-size: 20px;
	margin: 30px 0;
}

.benefits li {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	margin: 20px 0;

	span {
		width: calc(100% - 70px);
	}
}

.benefits li::before {
	content: '';
	background: url('~/assets/images/icon-check.png') no-repeat center center;
	background-size: 42px;
	height: 42px;
	width: 42px;
	display: block;
	margin: 0 20px 0 0;
}

@media (max-width: 1180px) {
	.benefits .column4 {
		width: 50%;
	}
}

@media (max-width: 920px) {
	.benefits {
		.column4 {
			width: 100%;
		}

		li {
			margin: 12px 0 12px -8px;
		}
	}
}
</style>
